import ObjectModel from "../objectModel";

export default class PublishedObjectModel extends ObjectModel {
  u_at: string;
  c_at: string;
  title: string;
  object_model_id: string;
}